import React from "react";
import { clinic } from "../../data/clinic";
import { parseDateKey } from "../../utils/slots";
import { formatLongDate, formatTime } from "../../utils/format";
import type { BookingStep } from "../../hooks/useBookingFlow";
import type { Service } from "../../types/booking";
interface BookingSummaryProps {
  service: Service | null;
  dateKey: string | null;
  time: string | null;
  onEdit: (step: BookingStep) => void;
}
export function BookingSummary({
  service,
  dateKey,
  time,
  onEdit
}: BookingSummaryProps) {
  return <aside className="rounded-3xl border border-line bg-white p-6 lg:sticky lg:top-28" aria-label="Récapitulatif" data-id="element-74" data-mp="22bgprs9hrrwv">
      <h2 className="text-sm font-semibold text-ink" data-id="element-75" data-mp="26axwsq4kgx45">Votre rendez-vous</h2>
      <dl className="mt-4 divide-y divide-line text-sm" data-id="element-76" data-mp="2bc53eluz3q98">
        <Row label="Soin" onEdit={service ? () => onEdit("service") : undefined} data-id="element-77" data-mp="3hrfqiigs4ln3">
          {service ? <>
              <span className="block font-medium text-ink" data-id="element-78" data-mp="3mppo0zpz7ybv">{service.name}</span>
              <span className="text-muted" data-id="element-79" data-mp="1l75b4755h2cm">
                {service.duration} min · {service.price}
              </span>
            </> : <span className="text-muted" data-id="element-80" data-mp="1g8vjg6imwjvr">À choisir</span>}
        </Row>
        <Row label="Date et heure" onEdit={time ? () => onEdit("slot") : undefined} data-id="element-81" data-mp="1b7xzpphz7hs5">
          {dateKey && time ? <span className="block font-medium text-ink" data-id="element-82" data-mp="169wgn4kjvigo">
              {formatLongDate(parseDateKey(dateKey))} à {formatTime(time)}
            </span> : <span className="text-muted" data-id="element-83" data-mp="xgt7h8gxtrru">À choisir</span>}
        </Row>
        <Row label="Lieu" data-id="element-84" data-mp="si85b3i4ky0r">
          <span className="block text-ink" data-id="element-85" data-mp="sjj9v5jea9sx">{clinic.street}</span>
          <span className="text-muted" data-id="element-86" data-mp="njwwmw3kgtk4">{clinic.city}</span>
        </Row>
      </dl>
    </aside>;
}
function Row({
  label,
  children,
  onEdit
}: {
  label: string;
  children: React.ReactNode;
  onEdit?: () => void;
}) {
  return <div className="flex items-start justify-between gap-4 py-4 first:pt-0 last:pb-0" data-id="element-87" data-mp="ek1g0br8s6cp">
      <div data-id="element-88" data-mp="3xllgp94x871">
        <dt className="text-xs text-muted" data-id="element-89" data-mp="3wtn56o5kwd2">{label}</dt>
        <dd className="mt-1" data-id="element-90" data-mp="8wy756o9s981">{children}</dd>
      </div>
      {onEdit && <button type="button" onClick={onEdit} className="text-xs font-medium text-brand hover:underline" data-id="element-91" data-mp="8y9bp8pjhl07">
          Modifier
        </button>}
    </div>;
}